import * as Yup from 'yup';

/**
 * 快递单号item
 */
export interface ExpressItem {
  /**
   * 快递单号
   */
  expressage_no: string;
}

/**
 * 商品快递
 */
export interface ExpressInfo {
  /**
   * 服务id(编辑的时候传)
   */
  id?: string;
  /**
   * 会员id
   */
  member_id?: string;
  /**
   * 非会员id
   */
  not_member_id?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 快递公司
   */
  courier_company?: string;
  /**
   * 收费总计
   */
  money?: string;
  /**
   * 物品数量
   */
  num?: string;
  /**
   * 收费pos号
   */
  pos_no?: string;
  /**
   * 是否到付，1到付，0已付
   */
  is_not_pay?: number;
  /**
   * 提交时转json字符串 里面包含以下数据,如果是修改里面要加id字段,如果删除的数据不要传给后台
   */
  expressage_items: ExpressItem[];
}

/**
 * 商品快递表单默认值
 */
export const defaultExpressInfo: ExpressInfo = {
  remark: '',
  courier_company: '顺丰',
  money: '0',
  num: '1',
  is_not_pay: null,
  expressage_items: [
    {
      expressage_no: '',
    }],
};

/**
 * 商品快递表单校验
 */
export const expressSchema = Yup.object().shape(
  {
    courier_company: Yup.string().ensure().required('请输入快递公司'),
    money: Yup.string().ensure().required('请输入收费总计').matches(/^\d+(\.(\d)*)?$/, '请输入正确的金额'),
    num: Yup.string().ensure().required('请输入物品数量').matches(/^[1-9]\d*$/, '请输入正确的数量'),
    expressage_items: Yup.array()
      .of(
        Yup.object({
          expressage_no: Yup.string().ensure().required('请输入快递单号'),
        })
      )
      .min(1, '请输入商品快递信息')
      .required('请输入商品快递信息'),
  }
);